import { encodePaginatableQuery, PaginatableQuery } from '@/services/api';

export type ActivityQuery = PaginatableQuery;

export const encodeActivityQuery = (query: ActivityQuery) => encodePaginatableQuery(query);
